// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/.pnpm/css-loader@7.1.2_webpack@5.98.0/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/.pnpm/css-loader@7.1.2_webpack@5.98.0/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `html {
  height: 100%;
  overflow: hidden;
}
body {
  height: 100vh;
  overflow-x: hidden;
}
#app-root {
  height: 100%;
}
.root-layout {
  min-height: 100%;
}
.ant-layout-sider {
  min-width: 256px !important;
  max-width: unset !important;
  width: 256px !important;
}
.ant-layout.page-layout {
  position: relative;
}
.ant-layout-content.page-content {
  display: flex;
  flex-shrink: 0;
}
.ant-layout-content.page-content .ant-table-wrapper {
  margin: 0 24px 24px 24px;
}
.ant-layout-header.page-header {
  background: transparent;
  padding: 0 24px;
  display: flex;
  align-items: center;
  height: 80px;
}
.ant-layout-header.page-header > .ant-row {
  width: 100%;
}
.page-header,
.page-content,
.app-footer {
  min-width: 420px;
}
.page-drawer {
  top: 64px;
  height: calc(100vh - 64px);
}
.ant-layout-content.page-content {
  flex-shrink: 0;
}
.ant-layout-content.page-content .ant-table-wrapper {
  margin: 0 24px 24px 24px;
}
.ant-layout-content.app-content {
  flex-shrink: 0;
}
.ant-breadcrumb-link > a > .anticon + span {
  margin-left: 4px;
}
span.content {
  color: rgba(0, 0, 0, 0.4);
}
.ant-input.code {
  font-family: monospace;
  white-space: pre;
  font-size: 12px;
}
`, "",{"version":3,"sources":["webpack://./src/app/styles/layout.less","webpack://./src/app/styles/app.less"],"names":[],"mappings":"AAAA;EACI,YAAA;EACA,gBAAA;ACCJ;ADEA;EACI,aAAA;EACA,kBAAA;ACAJ;ADGA;EACI,YAAA;ACDJ;ADIA;EACI,gBAAA;ACFJ;ADKA;EACI,2BAAA;EACA,2BAAA;EACA,uBAAA;ACHJ;ADMA;EACI,kBAAA;ACJJ;ADOA;EACI,aAAA;EACA,cAAA;ACLJ;ADGA;EAKQ,wBAAA;ACLR;ADSA;EACI,uBAAA;EACA,eAAA;EACA,aAAA;EACA,mBAAA;EACA,YAAA;ACPJ;ADSI;EACI,WAAA;ACPR;ADWA;;;EAGI,gBAAA;ACTJ;ADYA;EACI,SAAA;EACA,0BAAA;ACVJ;ADaA;EACI,cAAA;ACXJ;ADUA;EAIQ,wBAAA;ACXR;ADeA;EACI,cAAA;ACbJ;ADgBA;EACI,gBAAA;ACdJ;AAzDA;EACI,yBAAA;AA2DJ;AAxDA;EACI,sBAAA;EACA,gBAAA;EACA,eAAA;AA0DJ","sourcesContent":["html {\n    height: 100%;\n    overflow: hidden;\n}\n\nbody {\n    height: 100vh;\n    overflow-x: hidden;\n}\n\n#app-root {\n    height: 100%;\n}\n\n.root-layout {\n    min-height: 100%;\n}\n// added to fix layout with antd v5\n.ant-layout-sider {\n    min-width: 256px !important;\n    max-width: unset !important;\n    width: 256px !important;\n}\n\n.ant-layout.page-layout {\n    position: relative;\n}\n\n.ant-layout-content.page-content {\n    display: flex;\n    flex-shrink: 0;\n\n    .ant-table-wrapper {\n        margin: 0 24px 24px 24px;\n    }\n}\n\n.ant-layout-header.page-header {\n    background: transparent;\n    padding: 0 24px;\n    display: flex;\n    align-items: center;\n    height: 80px;\n\n    & > .ant-row {\n        width: 100%;\n    }\n}\n\n.page-header,\n.page-content,\n.app-footer {\n    min-width: 420px;\n}\n\n.page-drawer {\n    top: 64px;\n    height: calc(100vh - 64px);\n}\n\n.ant-layout-content.page-content {\n    flex-shrink: 0;\n\n    .ant-table-wrapper {\n        margin: 0 24px 24px 24px;\n    }\n}\n\n.ant-layout-content.app-content {\n    flex-shrink: 0;\n}\n\n.ant-breadcrumb-link > a > .anticon + span {\n    margin-left: 4px;\n}\n","@import 'layout.less';\n\nspan.content {\n    color: rgba(0, 0, 0, 0.4);\n}\n\n.ant-input.code {\n    font-family: monospace;\n    white-space: pre;\n    font-size: 12px;\n}\n\n@error-color: #EB0004;"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
